
<template>
    <div class="task-center-header">
       <div class="header-time" v-if="isShowTimer">
          <div 
            class="task-timer-desc" 
            v-if="ExpireShowType==2"
          >{{getTaskTimerDesc}}</div>
          <div class="task-timer">
           <svg xmlns="http://www.w3.org/2000/svg" style="width:1em;height:1em;vertical-align:middle" overflow="hidden" viewBox="0 0 48 48"><defs></defs><g :fill="timerIconColor"><path d="M24 5.5C13.23 5.5 4.5 14.23 4.5 25S13.23 44.5 24 44.5 43.5 35.77 43.5 25 34.77 5.5 24 5.5zm0 3c9.113 0 16.5 7.387 16.5 16.5S33.113 41.5 24 41.5 7.5 34.113 7.5 25 14.887 8.5 24 8.5z"/><path  d="M10.966 39.058a1.5 1.5 0 0 1 2.174 2.062l-.106.111-3 2.856a1.5 1.5 0 0 1-2.174-2.062l.106-.112 3-2.855zM8.94 3.94a1.5 1.5 0 0 1 2.224 2.007l-.103.114-6 6a1.5 1.5 0 0 1-2.225-2.008l.103-.114 6-6zm30.12 0a1.5 1.5 0 0 0-2.224 2.007l.103.114 6 6a1.5 1.5 0 0 0 2.225-2.008l-.103-.114-6-6zm-2.026 35.118a1.5 1.5 0 0 0-2.174 2.062l.106.111 3 2.856a1.5 1.5 0 0 0 2.174-2.062l-.106-.112-3-2.855zM24 15.5a1.5 1.5 0 0 1 1.493 1.356L25.5 17v7.533l5.275 3.183a1.5 1.5 0 0 1 .578 1.932l-.069.127a1.5 1.5 0 0 1-1.932.578l-.127-.069-6-3.62a1.5 1.5 0 0 1-.717-1.127l-.008-.157V17a1.5 1.5 0 0 1 1.5-1.5z"/></g></svg>
           <span v-if="ExpireShowType==2">{{taskTimer}}</span>
           <span v-if="ExpireShowType==1">{{time}}</span>
          </div>
       </div>
    </div>
</template>
<script>
import {secondToDate} from '@/common/js/utils.js'
export default {
  name: 'CountDown',
  props: {
    taskTimerDesc: {
      default: ''
    },
    taskTimer: {
      default: ''
    },
    ExpireShowType: {
      default: ''
    },
    RemainingSeconds: {
      default: ''
    },
    isShowTimer: {
      default: false
    }
  },
  computed: {

    getTaskTimerDesc () {
      return this.taskTimerDesc || this.$t('FoodC_C_The_end_yvSK')
    },
    timerIconColor () {
      // $color-primary-didi = #ff7a45
      // $color-primary-99 = #FEA32F
      return this.getCountry === 'BR' ? '#FEA32F' : ' #ff7a45'
    },
    // 获取对应的国家
    getCountry () {
      return this.$store.state.country
    }
  },
  watch: {
    RemainingSeconds: {
      handler (newV) {
        if (this.ExpireShowType === 1) {
          this.compTime(newV)
        }
      },
      immediate: true
    }
  },
  data () {
    return {
      second: 0,
      time: '',
      t: ''
    }
  },
  methods: {
    compTime (newV) {
      this.time = secondToDate(newV)
      this.second = newV - 1
      this.t = setInterval(() => {
        if (this.second <= 0) {
          clearInterval(this.t)
          this.$emit('get-task-init')
        } else {
          this.time = secondToDate(this.second)
          this.second--
        }
      }, 1000)
    }
  },
  destroyed () {
    clearInterval(this.t)
  }
}
</script>
<style lang="stylus" scoped>
@import "~@/common/stylus/variables"

.task-center-header
  // padding 32px 32px 68px 32px
  // display flex
  // justify-content space-between
  .header-time
    font-color()
    font-family 'Aspira Medium'
    font-size 32px
    font-weight 500
    display flex
    justify-content flex-end
    flex-wrap wrap-reverse
    .task-timer,
    .task-timer-desc
      line-height 40px
      display flex
      align-items center
      span
        margin-left 4px
    .task-timer
      margin-left 8px
</style>